import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Sayfa Bulunamadı - HatTravel</title>
        <meta name="description" content="Aradığınız sayfa bulunamadı." />
      </Helmet>
      
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h1" component="h1" gutterBottom sx={{ fontWeight: 700, fontSize: '6rem' }}>
            404
          </Typography>
          <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            Sayfa Bulunamadı
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            Aradığınız sayfa mevcut değil veya taşınmış olabilir.
          </Typography>
          <Button
            component={Link}
            to="/"
            variant="contained"
            size="large"
          >
            Ana Sayfaya Dön
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default NotFoundPage; 